import app from 'flarum/forum/app';

/*
 * Voucha ad measurement: Meta Pixel, Google tag, and a "created account" event.
 * Follows the Advertising choice in the theme's cookie banner (voucha-theme CookieConsent.js):
 * the tags load only when the vch_ads cookie is "yes", and load straight away when someone accepts.
 * Fill in the IDs below; an empty ID switches that platform off.
 */
const CONFIG = {
  metaPixelId: '',
  // e.g. '123456789012345'
  googleTagId: '',
  // e.g. 'AW-123456789' or 'G-XXXXXXX'
  googleAdsSignupConversion: '' // optional, e.g. 'AW-123456789/AbC-dEfGhIj'
};
const ATTR_KEY = 'voucha:attr';
const PENDING_KEY = 'voucha:pending-signup';
const ATTR_DAYS = 30;
const NEW_ACCOUNT_MINUTES = 30;
const ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
const ls = {
  get: k => {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  },
  set: (k, v) => {
    try {
      localStorage.setItem(k, v);
    } catch (e) {}
  },
  del: k => {
    try {
      localStorage.removeItem(k);
    } catch (e) {}
  }
};

/** The Advertising choice from the theme's banner: 'yes', 'no', or null (not chosen yet) */
function adsChoice() {
  const m = document.cookie.match(/(?:^|;\s*)vch_ads=([^;]*)/);
  const v = m ? decodeURIComponent(m[1]) : null;
  return v === 'yes' || v === 'no' ? v : null;
}

// 1. Remember where the visitor came from. Runs before the claim page replaces the address.
function captureAttribution() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    let any = false;
    ATTR_PARAMS.forEach(p => {
      const v = q.get(p);
      if (v) {
        found[p] = v.slice(0, 200);
        any = true;
      }
    });
    if (any) {
      found.at = Date.now();
      ls.set(ATTR_KEY, JSON.stringify(found));
    }
  } catch (e) {}
}
function attribution() {
  try {
    const a = JSON.parse(ls.get(ATTR_KEY) || 'null');
    if (!a || !a.at || Date.now() - a.at > ATTR_DAYS * 864e5) return null;
    return a;
  } catch (e) {
    return null;
  }
}

// 2. Ad tags, after consent only.
let loaded = false;
function loadTags() {
  if (loaded || !(CONFIG.metaPixelId || CONFIG.googleTagId)) return;
  loaded = true;
  const attr = attribution();
  if (CONFIG.metaPixelId) {
    // Meta reads the ad click from the _fbc cookie when it is no longer in the address.
    if (attr && attr.fbclid && document.cookie.indexOf('_fbc=') === -1) {
      document.cookie = '_fbc=fb.1.' + attr.at + '.' + encodeURIComponent(attr.fbclid) + ';max-age=7776000;path=/;SameSite=Lax';
    }
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', CONFIG.metaPixelId);
    window.fbq('track', 'PageView');
  }
  if (CONFIG.googleTagId) {
    // Google reads the ad click from the address when its tag starts; put it back briefly if it has gone.
    const restore = withClickIdsInAddress(attr, ['gclid', 'gbraid', 'wbraid']);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('consent', 'default', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted'
    });
    window.gtag('js', new Date());
    window.gtag('config', CONFIG.googleTagId);
    const g = document.createElement('script');
    g.async = true;
    g.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(CONFIG.googleTagId);
    g.onload = g.onerror = () => setTimeout(restore, 1500);
    document.head.appendChild(g);
  }
}
function withClickIdsInAddress(attr, keys) {
  try {
    if (!attr) return () => {};
    const u = new URL(window.location.href);
    let changed = false;
    keys.forEach(k => {
      if (attr[k] && !u.searchParams.has(k)) {
        u.searchParams.set(k, attr[k]);
        changed = true;
      }
    });
    if (!changed) return () => {};
    const before = window.location.href;
    const during = u.toString();
    window.history.replaceState(window.history.state, '', during);
    return () => {
      if (window.location.href === during) window.history.replaceState(window.history.state, '', before);
    };
  } catch (e) {
    return () => {};
  }
}

// 3. "Created account": the signed-in member joined in the last few minutes, sent once per account and browser.
function checkNewAccount() {
  const user = app.session && app.session.user;
  if (!user) return;
  const joined = user.joinTime && user.joinTime();
  if (!joined || Date.now() - joined.getTime() > NEW_ACCOUNT_MINUTES * 60e3) return;
  const flag = 'voucha:t:signup:' + user.id();
  if (ls.get(flag)) return;
  ls.set(flag, '1');
  const choice = adsChoice();
  if (choice === 'yes') sendSignup();else if (choice === null) ls.set(PENDING_KEY, '1'); // waits for the banner
}
function sendSignup() {
  const attr = attribution() || {};
  const data = {
    source: attr.utm_source || '',
    campaign: attr.utm_campaign || ''
  };
  if (window.fbq && CONFIG.metaPixelId) window.fbq('track', 'CompleteRegistration', data);
  if (window.gtag && CONFIG.googleTagId) {
    window.gtag('event', 'sign_up', data);
    if (CONFIG.googleAdsSignupConversion) window.gtag('event', 'conversion', {
      send_to: CONFIG.googleAdsSignupConversion
    });
  }
}
export default function setUpTracking() {
  captureAttribution();

  // A choice made in the banner on this page
  window.addEventListener('voucha:cookie-choice', e => {
    if (e.detail && e.detail.advertising) {
      loadTags();
      if (ls.get(PENDING_KEY)) {
        ls.del(PENDING_KEY);
        sendSignup();
      }
    } else {
      ls.del(PENDING_KEY);
    }
  });

  // The session exists once Flarum has finished booting, just after the initializers run.
  setTimeout(() => {
    if (adsChoice() === 'yes') loadTags();
    checkNewAccount();
  }, 0);
}